import { Tooltip } from '@mui/material'
import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useDayViewSettingsStore } from '../../../contexts/DayViewSettingsStore'
import { useRoomsStore } from '../../../contexts/RoomsStore'
import { OTHER_HEADERS } from '../../../utils/constantes'
import { getPictoByThemeId } from '../../../utils/pictos'
import './ColumnsHeaders.css'

const ColumnsHeaders = memo(({ place, nbGroups }) => {
  const rooms = useRoomsStore(useShallow((state) => state.rooms))
  const { printGroups } = useDayViewSettingsStore(
    useShallow((state) => ({
      printGroups: state.printGroups,
    }))
  )

  const roomsToPrint = Object.values(rooms)
    .filter((r) => r.place_id === place)
    .filter((r) => r.id < 100) // Filter out St Michel / Cardinal / etc ...
    .sort((r1, r2) => r1.id - r2.id)
  const otherHeadersToPrint = OTHER_HEADERS.filter((r) => r.place_id === place)
  const headers = [...roomsToPrint, ...otherHeadersToPrint]
  return (
    <div className="headersDayView dayViewLine">
      <div className="columnHeader entete">
        Salles
        <br />-<br />
        Horaires
      </div>
      {headers.map((h, i) => {
        const hasPicto = h?.theme_id
        const Picto = getPictoByThemeId(h?.theme_id)
        return (
          <Tooltip key={i} title={`${h?.name || h?.category}`} placement="top-start" arrow>
            <div className="columnHeader">
              {hasPicto ? (
                <Picto className="pictoRoom" />
              ) : (
                <div className="initialsHeader">{h?.initials}</div>
              )}
            </div>
          </Tooltip>
        )
      })}
      {printGroups && nbGroups > 0 && (
        <div
          style={{
            flex: nbGroups,
            paddingLeft: nbGroups - 1,
            minWidth: `calc(var(--min-width-day-view) * ${nbGroups})`,
          }}
          className="columnHeader groupHeader"
        >
          Groupes
        </div>
      )}
    </div>
  )
})
export default ColumnsHeaders
